import { Button, Group, Stack, Text } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import UnsubscribersListing from "./UnsubscribersListing";
import { Link } from "react-router-dom";
import { useLanguage } from "../../../../../stores/LanguageStore";

const LeftWrapperUnsubs = () => {
  const lang = useLanguage((s) => s.language);
  return (
    <Stack pos={"relative"} miw={430} flex={1}>
      <Group mt={16} opacity={1}>
        <Text size="xl" fw={600}>
          {lang.prospects.my_unsubscribers}
        </Text>

        <Button
          leftSection={<IconPlus />}
          size="md"
          radius={"md"}
          fz={16}
          ml={"auto"}
          component={Link}
          to={"/unsubscribers/import"}
        >
          {lang.unsubscribers.import.button_label}
        </Button>
      </Group>

      <UnsubscribersListing isMinimized />
    </Stack>
  );
};

export default LeftWrapperUnsubs;
